module.exports = __webpack_public_path__ + "static/img/bg_01.e2ba02d4.jpg";